module.exports = __webpack_public_path__ + "static/media/Follower_Button-19.02c8dc62.png";